import Material from '../../components/calculation-form/components/form-items/material'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const materialWidthColumn: CalculationColumn = {
    dataIndex: ['material', 'width'],
    title: 'Коррект. ширины',
    relationPath: ['material'],
    width: 62,
    editable: true,
    FormItem: <Material />,
    onCell: onAnyStandardCell,
}
